export const getPaymentLinksSettingsFromSettingsResponse = (settingsJson) => {
  const value = settingsJson?.data?.settings?.payment_links?.value;

  // Backend should normally return JSON as an object, but if the DB row is mis-typed
  // (e.g., setting_type != 'json'), it may come back as a JSON string.
  let v = {};
  if (value && typeof value === 'object') {
    v = value;
  } else if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (parsed && typeof parsed === 'object') {
        v = parsed;
      }
    } catch {
      // ignore parse errors and fall back to defaults
    }
  }

  const razorpayEnabled = Boolean(v?.razorpay?.enabled);
  const cashfreeEnabled = Boolean(v?.cashfree?.enabled);

  return {
    enabled: razorpayEnabled || cashfreeEnabled,
    defaultProvider: v?.defaultProvider || 'auto',
    razorpay: {
      enabled: razorpayEnabled
    },
    cashfree: {
      enabled: cashfreeEnabled
    }
  };
};

export const fetchPaymentLinksSettings = async ({ apiBase = '' } = {}) => {
  const res = await fetch(`${apiBase}/api/settings`);
  const json = await res.json();
  if (!res.ok || !json?.success) {
    throw new Error(json?.message || 'Failed to load settings');
  }
  return getPaymentLinksSettingsFromSettingsResponse(json);
};
